module.exports = __webpack_public_path__ + "png/quick-registration-photos.png?0948aaf88908824f0356c1e36104ab08";